import request from '@/utils/request'

// 查询举报类型列表
export function listReportType(query) {
  return request({
    url: '/report/report/type/list',
    method: 'get',
    params: query
  })
}

// 查询举报类型详细
export function getReportType(id) {
  return request({
    url: '/report/report/type/' + id,
    method: 'get'
  })
}

// 新增举报类型
export function addReportType(data) {
  return request({
    url: '/report/report/type',
    method: 'post',
    data: data
  })
}

// 修改举报类型
export function updateReportType(data) {
  return request({
    url: '/report/report/type',
    method: 'put',
    data: data
  })
}

// 删除举报类型
export function delReportType(id) {
  return request({
    url: '/report/report/type/' + id,
    method: 'delete'
  })
}
